import { render, staticRenderFns } from "./modalKlassCircle.vue?vue&type=template&id=ab07d604&scoped=true"
import script from "./modalKlassCircle.vue?vue&type=script&lang=js"
export * from "./modalKlassCircle.vue?vue&type=script&lang=js"
import style0 from "./modalKlassCircle.vue?vue&type=style&index=0&id=ab07d604&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab07d604",
  null
  
)

export default component.exports